import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Observable, map, catchError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginTypeEnum } from '../enums/loginType.enum';
import { TranslocoService } from '@ngneat/transloco';

export const canActivate: (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) =>
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  const translocoService = inject(TranslocoService);

  return authenticationService.isLoggedIn().pipe(
    map((isLoggedIn) => {
      if (isLoggedIn) {
        return true;
      } else {
        throw translocoService.translate('errors.userLogin');
      }
    }),
    catchError(() => {
      if (environment.loginType === LoginTypeEnum.User) {
        return router.navigate(['/login'], {
          queryParams: { returnUrl: state.url },
        });
      } else {
        return router.navigateByUrl('/');
      }
    }),
  );
};

export const canActivateChild: (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) =>
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
  canActivate(route, state);
